import React, { useState } from 'react'
import { Modal, Button, Popover, List, Card } from 'antd'

const DeletePropModal = ({
  visible,
  onCancel,
  onDelete,
  modalKey,
  modalUsages,
  displayMap = {},
  propReference = {},
  replacementKey,
  setReplacementKey
}) => {
  const [mapPopoverVisible, setMapPopoverVisible] = useState(false)

  const otherKeys = Object.keys(displayMap || {}).filter(k => k !== modalKey)
  const needsReplacement =
    modalUsages && modalUsages.length > 0 && otherKeys.length > 0

  return (
    <Modal
      visible={visible}
      title={
        modalKey
          ? `Delete prop reference "${modalKey}"`
          : 'Delete prop reference'
      }
      onCancel={onCancel}
      onOk={onDelete}
      centered
      okType="danger"
      cancelText="Cancel"
      width={720}
      okText={needsReplacement ? 'Replace & Delete' : 'Delete'}
      okButtonProps={{ disabled: needsReplacement && !replacementKey }}
    >
      {modalKey && (
        <div>
          {modalUsages && modalUsages.length > 0 ? (
            <div>
              <p style={{ marginBottom: 8 }}>
                This prop reference is being used in some scenes/shots. Select
                an existing prop to map occurrences in those prompts before
                deleting.
              </p>

              <div className="lr-map-to-row">
                <div className="lr-map-to-label" style={{ fontWeight: 600 }}>
                  Map to
                </div>

                <Popover
                  placement="bottomLeft"
                  visible={mapPopoverVisible}
                  onVisibleChange={v => setMapPopoverVisible(v)}
                  content={
                    <div className="lr-map-popover">
                      <List
                        size="small"
                        dataSource={otherKeys}
                        renderItem={k => {
                          const description = displayMap[k]
                          const refs = propReference || {}
                          const refKey = refs[`__${k}__`] ? `__${k}__` : k
                          const reference = refs[refKey]
                          const imageSrc =
                            reference &&
                            (reference.uri ||
                              reference.url ||
                              reference.image ||
                              reference.src)

                          return (
                            <List.Item
                              className={`lr-map-popover-item ${
                                replacementKey === k ? 'selected' : ''
                              }`}
                              onClick={() => {
                                setReplacementKey(k)
                                setMapPopoverVisible(false)
                              }}
                            >
                              <div className="lr-map-item-image">
                                {imageSrc ? (
                                  <img
                                    src={imageSrc}
                                    alt={k}
                                    style={{
                                      height: '100%',
                                      width: 'auto',
                                      objectFit: 'cover',
                                      borderRadius: 4
                                    }}
                                  />
                                ) : (
                                  <div className="lr-no-image">No Image</div>
                                )}
                              </div>
                              <div className="lr-map-item-details">
                                <div className="lr-map-item-title">{k}</div>
                                <div className="lr-map-item-desc">
                                  {String(description || '')}
                                </div>
                              </div>
                            </List.Item>
                          )
                        }}
                      />
                    </div>
                  }
                  trigger="click"
                >
                  <Button className="lr-map-to-button">
                    {replacementKey
                      ? `Mapped: ${replacementKey}`
                      : 'Choose prop to map to'}
                  </Button>
                </Popover>
              </div>

              <div
                style={{
                  maxHeight: '40vh',
                  overflow: 'auto',
                  paddingRight: 8
                }}
              >
                {modalUsages.reduce((acc, u) => {
                  acc[u.sceneTitle] = acc[u.sceneTitle] || []
                  acc[u.sceneTitle].push(u)
                  return acc
                }, {}) &&
                  Object.entries(
                    modalUsages.reduce((acc, u) => {
                      acc[u.sceneTitle] = acc[u.sceneTitle] || []
                      acc[u.sceneTitle].push(u)
                      return acc
                    }, {})
                  ).map(([sceneTitle, items]) => (
                    <div key={sceneTitle} style={{ marginBottom: 12 }}>
                      <Card size="small" style={{ background: '#fafafa' }}>
                        <div
                          className="lr-scene-title"
                          style={{
                            fontSize: '16px',
                            fontWeight: 600,
                            margin: '6px 0'
                          }}
                        >
                          {sceneTitle}
                        </div>
                        <div style={{ marginTop: 8 }}>
                          <ul style={{ margin: 0 }}>
                            {items
                              .filter(i => i.type === 'shot')
                              .map((it, idx) => (
                                <li key={idx} style={{ marginBottom: 6 }}>
                                  <span style={{ fontWeight: 600 }}>
                                    {it.shotTitle}
                                  </span>
                                  {it.dialogueMatches &&
                                    it.dialogueMatches.length > 0 && (
                                      <span
                                        style={{ color: '#888' }}
                                      >{` (Dialogue: ${it.dialogueMatches
                                        .map(d => d.character)
                                        .join(', ')})`}</span>
                                    )}
                                </li>
                              ))}
                          </ul>
                        </div>
                      </Card>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div>
              <p>
                This prop reference does not appear to be used in any scene or
                shot.
              </p>
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}

export default DeletePropModal
